import { useMemo } from "react";
import useMutation from "hooks/useMutation";
import CheckoutService from "services/CheckoutService";
import type { CheckoutResponse } from "services/CheckoutService";
import useUserContext from "hooks/useUserContext";

/**
 * @description Creates a Stripe checkout session for buying additional sensors and
 * returns the URL the user has to be redirected to. The mutation key is scoped to the
 * organisation's Stripe customer id so checkouts are never shared between organisations,
 * and is `null` while the organisation has no Stripe customer, which stops the mutation
 * from being triggered at all.
 */
function useCheckoutSensorMutation() {
  const [{ profile }] = useUserContext();

  const mutationKey = useMemo(() => {
    return ["CheckoutService.createSensorCheckout", profile?.id] as const;
  }, [profile?.id]);

  return useMutation<CheckoutResponse, Error, typeof mutationKey>(mutationKey, () =>
    CheckoutService.createSensorCheckout()
  );
}

export default useCheckoutSensorMutation;
